// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"34649252","703":"740e0cea"}[chunkId] + ".chunk.js";
};